/* eslint-disable */
/* eslint-disable sonarjs/no-duplicate-string */
import { faSlidersH, faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Icon,
  makeStyles,
  RACCheckBox,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTooltip,
  RACTextField,
  RACCOLOR,
} from '@rentacenter/racstrap';
import { CancelTokenSource } from 'axios';
import clsx from 'clsx';
import React, { useEffect, useRef, useState, useMemo, useContext } from 'react';
import { RACInfiniteScroll } from '../../common/RACInfiniteScroll/RACInfiniteScroll';
import { getCancelTokenSource } from '../../api/client';
import { getPurchaseOrders } from '../../api/purchaseOrders';
import {
  COLUMN_TEXT_LIMIT,
  INITIAL_OFFSET,
  POSection,
  RegularPOStatusTypes,
  ReceiveNowType,
  RECEIVING_PO_API_LIMIT,
  RegularPOTypes,
} from '../../constants/constants';
import { ReceiveNowActions } from './ReceiveNowActions';
import {
  GetPurchaseOrderRequest,
  GetPurchaseOrderResponse,
  MotorcycleAttributes,
  PurchaseOrder,
  PurchaseOrderDetail,
  UpdatedPOInformation,
} from '../../types/types';
import {
  formatDateString,
  formatMoney,
  getPONumber,
  getSelectedStore,
} from '../../utils/utils';
import {
  SearchStateContext,
  useSearchActions,
  useSearchDetails,
} from '../../context/Search/SearchProvider';
import { FieldWithTooltip } from '../../common/FieldWithTooltip/FieldWithTooltip';
import { AutoNumeric } from '../../common/AutoNumeric/AutoNumeric';
import { useGlobalContext } from '../../context/global/GlobalContext';
import {
  setSelectedPOToReceive,
  setUpdatedPOData,
} from '../../context/global/reducer/selectedPOToReceiveActions';
import { useUserStateContext } from '../../context/user/user-contexts';
import { useTranslation } from 'react-i18next';

import { useStoreDetails } from '../../context/Store/StoreProvider';

import { ReactComponent as EditIcon } from '../../app/assets/img/edit.svg';
import {ReactComponent as Scanner} from '../../app/assets/img/qr-scanner.svg';
import { boolean } from 'yup';
import ReceivingInfoModal from './ReceivingInfoModal';

export const regularPOListTestId = 'regularPOListTestId';

const useClasses = makeStyles((theme: any) => ({
  purchaseOrderListWrapper: {
    width: '100%',
    height: theme.typography.pxToRem(284),
  },
  purchaseOrderList: {
    flexDirection: 'row',
    boxSizing: 'border-box',
    borderRadius: '1rem',
    overflowX: 'auto',
    height: theme.typography.pxToRem(297),
  },
  paddingTopBottom8: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: 'white'

  },
  tableHeader: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: 'white',
  },
  contentHeight: {
    height: theme.typography.pxToRem(233),
  },
  mainTableCell: {
    fontWeight: 'bolder',
    fontSize: '1rem',
    paddingright: '1rem',
  },
  childTableCellWidth50: {
    width: theme.typography.pxToRem(50),
  },
  childTableCellWidth130: {
    width: theme.typography.pxToRem(130),
  },
  childTableCellWidth73: {
    width: theme.typography.pxToRem(44),
    minWidth: theme.typography.pxToRem(44),
  },
  minWidth100: {
    minWidth: theme.typography.pxToRem(125),
  },
  childTableCellWidth100: {
    width: theme.typography.pxToRem(125),
  },
  childTableCellWidth150: {
    width: theme.typography.pxToRem(150),
  },
  childTableCellWidth170: {
    width: theme.typography.pxToRem(170),
  },
  childTableCellWidth250: {
    width: theme.typography.pxToRem(250),
  },
  childTableCellWidth: {
    width: theme.typography.pxToRem(180),
  },
  mainTableCellWrapper: {
    display: 'flex',
  },
  mainTableCellWidth100: {
    width: theme.typography.pxToRem(125),
  },
  fieldWidth70percent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '50%',
    minWidth: theme.typography.pxToRem(600),
  },
  fieldWidth70percentMX: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '70%',
    minWidth: theme.typography.pxToRem(600),
  },
  checkboxChecked: {
    display: 'flex',
  },
  disabled: {
    opacity: '',
  },
  mainCheckbox: {
    width: `${theme.typography.pxToRem(40)} !important`,
  },
  checkbox: {
    padding: '0',
    width: theme.typography.pxToRem(100),
    height: theme.typography.pxToRem(50),
    '& svg': {
      width: theme.typography.pxToRem(26),
      height: theme.typography.pxToRem(26),
    },
  },
  receivedDetailContainer: {
    display: 'inline-flex',
    paddingLeft: theme.typography.pxToRem(50),
    fontSize: theme.typography.pxToRem(14),
    width: '100%',
  },
  receivedDetailLabel: {
    fontWeight: 'bolder',
  },
  receivedDetailValue: {
    fontSize: theme.typography.pxToRem(14),
  },
  receivedDetailItem: {
    width: theme.typography.pxToRem(200),
    marginRight: '5%',

  },
  receivedDetailComment: {
    width: '100%',
    maxWidth: theme.typography.pxToRem(300),
    marginRight: '5%',
  },
  receivedDetailDateReceived: {
    width: '100%',
    maxWidth: theme.typography.pxToRem(300),
    display: 'flex',
  },
  receivedDetailDateReceivedLabel: {
    marginRight: theme.typography.pxToRem(10),
  },
  mainCellContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  mainCellDateColumn: {
    display: 'flex',
    flexGrow: 4,
    justifyContent: 'end',
  },
  marginRight5: {
    marginRight: theme.typography.pxToRem(5),
  },
  mainTableDateCell: {
    marginLeft: theme.typography.pxToRem(47),
  },
  field: {
    width: '12rem',
    '& input': {
      height: theme.typography.pxToRem(25),
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '6%',
  },
  icon: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(20),
    height: '100%',
  },
  fieldFlex: {
    display: 'flex',
    justifyContent: 'end',
    width: theme.typography.pxToRem(10),
  },
  actionCell: {
    display: 'flex',
    paddingLeft: '20px',
    height: '100%',
  },
  scannerIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '10px',
    top: '68%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  },
  fieldTotalCost : {

  },
  '@media (max-width: 800px)': {
    tableHeader: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: 'white',
    width: theme.typography.pxToRem(125),
    minWidth: theme.typography.pxToRem(125),
  },
   mainTableCellWidth100: {
    width: theme.typography.pxToRem(204.2),
  },

    fieldWidth70percentMX: {
     display: 'grid', // Use grid layout
     gridTemplateColumns: 'repeat(2, 1fr)', // Create two equal columns
     gap: theme.typography.pxToRem(10), // Space between grid items
     width: '100%', // Full width on smaller screens
     minWidth: 'auto', // Remove minWidth constraint
  },
   fieldVendorName: {
    width: '100%', // Half width for Vendor Name
    marginBottom: theme.typography.pxToRem(10), // Space below
  },
  
  fieldTotalCost: {
    width: '100%', // Half width for Total Cost
    marginBottom: theme.typography.pxToRem(10), // Space below
  },

  fieldEta: {
    width: '100%', // Half width for ETA
    marginBottom: theme.typography.pxToRem(10), // Space below
  },
  
  fieldBool: {
    width: '100%', // Half width for BOL
    marginBottom: theme.typography.pxToRem(10), // Space below
  },
 
   bolFieldContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
    scannerIcon: {
    width: '15px', // Adjust scanner icon size
    height: '15px',
    position: 'absolute',
    right: '12px', // Adjust position
    // top: '50%', // Center vertically
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  },
    purchaseOrderListWrapper: {
      height: 'auto', 
    },
    purchaseOrderList: {
      flexDirection: 'column', 
      height: 'auto', 
    },
    mainTableCell: {
      fontSize: '0.9rem', 
    },
    icon: {
      fontSize: theme.typography.pxToRem(18), // Adjust icon size
      paddingBottom:'1500%',
      marginRight: '150%',
    },
  
      },

}));

export const trimText = (text: string | undefined) => {
  if (!text) return '';

  if (text.length > COLUMN_TEXT_LIMIT)
    return `${text.substring(0, COLUMN_TEXT_LIMIT)}...`;

  return text;
};

export const trimTextWithTooltip = (
  text: string | undefined,
  length: number = COLUMN_TEXT_LIMIT
) => {
  if (!text) return '';

  if (text.length > length) {
    return (
      <RACTooltip title={text}>
        <span>{trimText(text)}</span>
      </RACTooltip>
    );
  }

  return text;
};

export interface ReceivedDetailRowProps {
  isDisabled?: boolean;
  isPartial?: boolean;
  poReceivedDetail: any;
  isPreviouslyReceived: boolean;
  closeCancelDate?: string;
  partialReceivedPO: UpdatedPOInformation[];
  index: number;
  dateReceivedColumnNeeded?: boolean;
}




export const generateFlatReceivedDetails = (
  poReceivedDetails: PurchaseOrderDetail[]
) => {
  const flatPOReceivedDetails: any[] = [];

  poReceivedDetails.forEach((item) => {

    const totalPONotReceived = item?.quantityOrdered - (item?.receivedCount || 0);


    const receivedVehicleIds = item.purchaseOrderReceivedDetails?.flatMap(detail =>
      detail?.poVehicleDetails?.map(vehicle => vehicle?.vehicleId)
    ) || [];


    const unreceivedVehicles = (item?.vehicleDetails || []).filter(vehicle =>
      vehicle.vehicleId !== undefined && !receivedVehicleIds.includes(vehicle.vehicleId)
    );

    unreceivedVehicles.forEach(vehicle => {
      flatPOReceivedDetails.push({
        ...item,
        ...vehicle,
        received: false,
      });
    });

    const unreceivedItemsWithoutVehicleCount = totalPONotReceived - unreceivedVehicles.length;
    for (let i = 0; i < unreceivedItemsWithoutVehicleCount; i++) {
      flatPOReceivedDetails.push({
        ...item,
        received: false,
      });
    }

    if (item.purchaseOrderReceivedDetails?.length) {
      item.purchaseOrderReceivedDetails.forEach(detail => {
        flatPOReceivedDetails.push({
          ...item,
          ...detail,
          received: true,
        });
      });
    }
  });

  return flatPOReceivedDetails;
};

export const ReceivedDetailRow = ({
  index,
  partialReceivedPO,
  poReceivedDetail,
  isDisabled,
  isPartial,
  isPreviouslyReceived,
  closeCancelDate,
  dateReceivedColumnNeeded = false,
}: ReceivedDetailRowProps) => {
  const classes = useClasses();
  const piecesPerItems = isPartial
    ? 0
    : poReceivedDetail?.receivedLineItemDetails?.[0].piecesReceived || 0;
  const updatedPartialReceivedPO = partialReceivedPO.find(
    (item) =>
      (!!item.poLineItemReceivedId &&
        item.poLineItemReceivedId ===
        poReceivedDetail?.receivedLineItemDetails?.[0]
          .poLineItemReceivedId) ||
      (!item?.poLineItemReceivedId &&
        item.purchaseOrderDetailId === poReceivedDetail.purchaseOrderDetailId &&
        item.purchaseOrderDetailIndex === index)
  );
  let comments = '-';
  if (updatedPartialReceivedPO) {
    if (updatedPartialReceivedPO.action === ReceiveNowType.Partial) {
      comments = updatedPartialReceivedPO.comment || '-';
    }
  } else {
    comments =
      poReceivedDetail?.receivedLineItemDetails?.[0].receivedComments || '-';
  }

  let previouslyReceived = 'No';
  if (isPreviouslyReceived) {
    previouslyReceived = 'All';
  } else if (isPartial) {
    previouslyReceived = 'Partial';
  }

  const isClosedCancelled = closeCancelDate ? true : false;
  const { t } = useTranslation()

  return (
    <RACTableRow >
      <RACTableCell
        classes={{
          root: clsx(classes.paddingTopBottom8, isDisabled && classes.disabled),
        }}
        style={isDisabled ? { backgroundColor: 'lightblue' } : {}}
        colSpan={10}
      >
        <div className={classes.receivedDetailContainer}>
          <div className={classes.receivedDetailItem}>
            <span className={classes.receivedDetailLabel}>{t("MFG. Model #")} </span>
            <span className={classes.receivedDetailValue}>
              {'  '}
              {trimTextWithTooltip(poReceivedDetail?.modelNumber) || ''}
            </span>
          </div>
          <div className={classes.receivedDetailItem}>
            <span className={classes.receivedDetailLabel}>{t('Pieces/Items')} </span>
            <span className={classes.receivedDetailValue}>
              {` ${piecesPerItems}`}
            </span>
          </div>
          <div className={classes.receivedDetailItem}>
            <span className={classes.receivedDetailLabel}>
              {t("Previously Received")}
            </span>
            <span className={classes.receivedDetailValue}>
              {`  ${t(previouslyReceived)}`}
            </span>
          </div>
          <div className={classes.receivedDetailComment}>
            <span className={classes.receivedDetailLabel}>{t("Comments")}</span>
            <span
              className={classes.receivedDetailValue}
            >{`  ${trimTextWithTooltip(comments)}`}</span>
          </div>
          {dateReceivedColumnNeeded && (
            <div className={classes.receivedDetailDateReceived}>
              <div className={classes.receivedDetailDateReceivedLabel}>
                {t('Date Received')}{' '}
              </div>
              <div className={classes.receivedDetailValue}>
                {formatDateString(
                  poReceivedDetail?.receivedLineItemDetails?.[0]
                    .poLineItemReceivedDate
                ) || ''}
              </div>
            </div>
          )}
          {isClosedCancelled && (
            <div className={classes.receivedDetailDateReceived}>
              <div className={classes.receivedDetailDateReceivedLabel}>
                {t('Date Closed/Cancelled')}{' '}
              </div>
              <div className={classes.receivedDetailValue}>
                {formatDateString(closeCancelDate) || ''}
              </div>
            </div>
          )}
        </div>
      </RACTableCell>
    </RACTableRow>

  );
};

export const getTotalPOItems = (details: PurchaseOrderDetail[]) => {
  return details.reduce(
    (acc, detail) => {
      const ordered = Number(detail?.quantityOrdered ?? 0);
      const canceled = Number(detail?.quantityCanceled ?? 0);

      const received =
        detail?.receivedCount != null
          ? Number(detail.receivedCount)
          : detail?.purchaseOrderReceivedDetails?.length ?? 0;

      acc.totalOrdered += ordered;
      acc.totalCanceled += canceled;
      acc.totalReceived += received;

      return acc;
    },
    {
      totalOrdered: 0,
      totalCanceled: 0,
      totalReceived: 0
    }
  );
};

const poExistInUpdatedList = (
  hasPOLineItemReceivedId: boolean,
  poReceived: any,
  index: number,
  partialReceivedPOs: UpdatedPOInformation[]
) =>
  partialReceivedPOs?.find(
    (item) =>
      (hasPOLineItemReceivedId &&
        item.poLineItemReceivedId ===
        poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId) ||
      (!hasPOLineItemReceivedId &&
        item.purchaseOrderDetailId === poReceived?.purchaseOrderDetailId &&
        index === item.purchaseOrderDetailIndex)
  );

export const handlePartialRefusalSubmitted = (
  purchaseOrderId: string,
  reason: string,
  comment: string,
  poReceived: any,
  index: number,
  action: string,
  partialReceivedPOs: UpdatedPOInformation[],
  poType = ''
): UpdatedPOInformation[] => {
  const hasPOLineItemReceivedId =
    !!poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId;
  const partialPO = poExistInUpdatedList(
    hasPOLineItemReceivedId,
    poReceived,
    index,
    partialReceivedPOs
  );

  if (partialPO) {
    const otherPartialPos = partialReceivedPOs?.filter(
      (item) =>
        (hasPOLineItemReceivedId &&
          item.poLineItemReceivedId !==
          poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId) ||
        (!hasPOLineItemReceivedId &&
          item.purchaseOrderDetailId === poReceived?.purchaseOrderDetailId &&
          index !== item.purchaseOrderDetailIndex) ||
        item.purchaseOrderDetailId !== poReceived?.purchaseOrderDetailId
    );

    if (
      poReceived.manufacturerSerialNumber &&
      !partialPO.manufacturerSerialNumber
    ) {
      partialPO.manufacturerSerialNumber = poReceived.manufacturerSerialNumber;
    }

    return [
      ...otherPartialPos,
      {
        ...partialPO,
        comment,
        reason,
        action,
        billOfLading: '',
        poType: poType,
      },
    ];
  } else {
    const partial: UpdatedPOInformation = {
      purchaseOrderId,
      purchaseOrderDetailId: poReceived?.purchaseOrderDetailId,
      purchaseOrderDetailIndex: index,
      purchaseOrderDetailReceivedId: poReceived?.purchaseOrderDetailReceivedId,
      poLineItemReceivedId:
        poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId,
      comment,
      reason,
      action,
      billOfLading: '',
    };

    if (poReceived.manufacturerSerialNumber) {
      partial.manufacturerSerialNumber = poReceived.manufacturerSerialNumber;
    }

    partial.poType = poType;

    return [...partialReceivedPOs, partial];
  }
};

export const addSerialNumberabdBol = (
  purchaseOrderId: string,
  manufacturerSerialNumber: string | null,
  billOfLading: string | null,
  poReceived: any,
  index: number,
  partialReceivedPOs: UpdatedPOInformation[],
  poType = '',
  poVehicleId?: any
  // eslint-disable-next-line sonarjs/cognitive-complexity
): UpdatedPOInformation[] => {
  const hasPOLineItemReceivedId =
    !!poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId;
  const partialPO = poExistInUpdatedList(
    hasPOLineItemReceivedId,
    poReceived,
    index,
    partialReceivedPOs
  );

  if (partialPO) {
    const otherPartialPos = partialReceivedPOs?.filter(
      // eslint-disable-next-line sonarjs/no-identical-functions
      (item) =>
        (hasPOLineItemReceivedId &&
          item.poLineItemReceivedId !==
          poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId) ||
        (!hasPOLineItemReceivedId &&
          item.purchaseOrderDetailId === poReceived?.purchaseOrderDetailId &&
          index !== item.purchaseOrderDetailIndex) ||
        item.purchaseOrderDetailId !== poReceived?.purchaseOrderDetailId
    );

    const updatedPartialPO = { ...partialPO };

    if (manufacturerSerialNumber !== null) {
      updatedPartialPO.manufacturerSerialNumber =
        manufacturerSerialNumber.trim();
    } else if (poReceived?.manufacturerSerialNumber) {
      updatedPartialPO.manufacturerSerialNumber =
        poReceived?.manufacturerSerialNumber;
    }

    if (billOfLading !== null) {
      updatedPartialPO.billOfLading = billOfLading.trim();
    }
    updatedPartialPO.purchaseOrderVehicleDetailId = poVehicleId ? poVehicleId : undefined

    return [...otherPartialPos, { ...updatedPartialPO, poType: poType }];
  } else {
    const partial: UpdatedPOInformation = {
      purchaseOrderId,
      purchaseOrderDetailId: poReceived?.purchaseOrderDetailId,
      purchaseOrderDetailIndex: index,
      purchaseOrderDetailReceivedId: poReceived?.purchaseOrderDetailReceivedId,
      poLineItemReceivedId:
        poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId,
      billOfLading,
    };

    if (manufacturerSerialNumber !== null) {
      partial.manufacturerSerialNumber = manufacturerSerialNumber.trim();
    } else if (poReceived?.manufacturerSerialNumber) {
      partial.manufacturerSerialNumber = poReceived?.manufacturerSerialNumber;
    }

    if (billOfLading !== null) {
      partial.billOfLading = billOfLading.trim();
    }

    partial.poType = poType;

    partial.purchaseOrderVehicleDetailId = poVehicleId ? poVehicleId : undefined

    return [...partialReceivedPOs, partial];
  }
};

export interface POListProps {
  expanded: boolean;
}

export interface BolandSerialPropsType {
  receivedId: string;
  poInUpdatedPOList: UpdatedPOInformation | undefined;
  poReceived: any;
  purchaseOrderId: string;
  index: number;
  isSelected: boolean;
  partialReceivedPOs: UpdatedPOInformation[];
  distributionCenter : any;
  
  
  // setPartialReceivedPOs : React.Dispatch<React.SetStateAction<UpdatedPOInformation[]>>
}

export const RegularPOList = ({ expanded }: POListProps) => {
  // eslint-disable-next-line no-console
  console.log('inside RegularPOSection component');
  const initialCallToken = useRef<CancelTokenSource>();
  const { user } = useUserStateContext();
  const [hasApiError, setApiHasError] = useState(false);
  const [purchaseOrders, setPurchaseOrders] = useState<PurchaseOrder[]>([]);
  const [selectedPO, setSelectedPO] = useState('');
  const [selectedReceivedDetailPO, setSelectedReceivedDetailPO] = useState<
    string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState<number>(INITIAL_OFFSET);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const [vendorName, setVendorName] = useState('');
  const { t } = useTranslation()
  const [totalCost, setTotalCost] = useState('');
  const [eta, setEta] = useState('');

  const { setBol } = useSearchActions();
  const { bol } = useSearchDetails();
  const [receivingMotorcycleInfo, setReceivingMotorcycleInfo] = useState(false);
  const [isReceivingInfoModalOpen, setReceivingInfoModalOpen] = useState(false);


  const [serialProps, setSerialProps] = useState<BolandSerialPropsType | null>(null)
  const [serialNumbers, setSerialNumbers] = useState<{ [key: string]: string }>({});
  const [validatedMotorcycleDetails, setValidatedMotorcycleDetails] = useState<{ [key: string]: MotorcycleAttributes }>({}); 


  let bolandSerialProps: any = {
    receivedId: "",
    poInUpdatedPOList: undefined,
    poReceived: {},
    purchaseOrderId: "",
    index: 0,
    isSelected: true,
    distributionCenter:"",
  }



  const { setSearchedPOInSection, setRegularPOLoading, setSearchItemFound, setPartialReceivedPOs } =
    useSearchActions();
  const {
    filter,
    manualPOReceive,
    reloadData,
    queryParamsProp,
    partialReceivedPOs,
    enableMXPOReceivingValue,
    oracleFusionEnableValue,
  } = useSearchDetails();
  const isOracleFusionEnabled = oracleFusionEnableValue === '1';
  // eslint-disable-next-line no-console
  console.log('inside RegularPOSection component', queryParamsProp);
  const { poNumber, toDate, fromDate } = filter || {};
  const classes = useClasses();
  const isPurchaseOrdersEmpty = !purchaseOrders || purchaseOrders?.length === 0;
  const { dispatch } = useGlobalContext();

  // const { store } = useStoreDetails();

  // const storeCountry: string | undefined = store?.countryAbb


  const renderTableHead = () => (
    <>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth73),
        }}
      />
      <RACTableCell
        classes={{
          root: clsx(
            classes.tableHeader,
            classes.childTableCellWidth100,
            classes.minWidth100
          ),
        }}
      >
        {t("PO #")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(
            classes.tableHeader,
            classes.childTableCellWidth100,
            classes.minWidth100
          ),
        }}
      >
        {t("Created")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t("Item #")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t("Model #")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth250),
        }}
      >
        {t("Description")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t("Brand")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth100),
        }}
      >
        {t("Cost")}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t("Receiving Now")}
      </RACTableCell>
      {enableMXPOReceivingValue != "1" ?
        (<><RACTableCell
          classes={{
            root: clsx(classes.tableHeader, classes.childTableCellWidth150),
          }}
        >
          {t("Serial #")}
        </RACTableCell><RACTableCell
          classes={{
            root: clsx(classes.tableHeader, classes.childTableCellWidth150),
          }}
        >
            {t("Bol")}
          </RACTableCell></>) :
        (<RACTableCell
          classes={{
            root: clsx(classes.tableHeader, classes.childTableCellWidth150),
          }}
        >
          {t("Action")}
        </RACTableCell>)

      }
    </>
  );

  const renderTableContent = () => {
    if (isPurchaseOrdersEmpty) return <></>;

    return renderTableContentFilled();
  };

  const clearPOFields = () => {
    setVendorName('');
    setTotalCost('');
    setEta('');
    dispatch(setSelectedPOToReceive({} as PurchaseOrder));
    setBol('')
    setSerialNumbers({})
    setValidatedMotorcycleDetails({})
  };

  const onPOSelection = (po: PurchaseOrder) => {
    const poNumber = String(po.purchaseOrderNumber);
    const clearPo = selectedPO === poNumber;
    clearPo ? setSelectedPO('') : setSelectedPO(poNumber);
    setPartialReceivedPOs([]);
    setSelectedReceivedDetailPO([]);
    setSerialNumbers({})
     setValidatedMotorcycleDetails({})
    setBol('')

    if (clearPo) {
      clearPOFields();
    } else {
      po.vendorName && setVendorName(po.vendorName);
      setTotalCost(po.totalCost);
      po.estimatedDeliveryDate &&
        setEta(formatDateString(po.estimatedDeliveryDate));
      dispatch(setSelectedPOToReceive(po));
    }
    dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
  };
 
  const updateCancelledLineItems = (po: any) => {
    if ( po?.purchaseOrderDetails ) {
      po?.purchaseOrderDetails.map( (oneDetail : any) => { 
        if ( Number(oneDetail.quantityCanceled) > 0 ) {
          oneDetail.quantityOrdered = oneDetail.quantityOrdered - oneDetail.quantityCanceled;
          oneDetail.quantityCanceled = 0;
        }
      } );       
    }

    return po;
  };

  const discardPO = (po : any ) => {
    if ( po?.purchaseOrderDetails ) {

      let allItemsCancelled = true;

      po.purchaseOrderDetails.forEach( (onePO : any) => {
        if ( onePO.quantityCanceled != onePO.quantityOrdered ) {
          allItemsCancelled = false
        }

      } );
      return allItemsCancelled;
    }

    return false;
  };
  const renderTableContentFilled = () => (
    <>
      {purchaseOrders?.map((po, index) => {
        if ( discardPO(po) ) return null;
        po = updateCancelledLineItems(po);
        const poNumber = String(po.purchaseOrderNumber);
        const showPODetail = poNumber === selectedPO && po.purchaseOrderDetails;

        return (
          <RACTableRow key={index} backgroundColor="white">
            <>
              <RACTableCell
                classes={{
                  root: clsx(
                    classes.paddingTopBottom8,
                    classes.childTableCellWidth100
                  ),
                }}
                colSpan={11}
              >
                <div className={classes.mainCellContainer}>
                  <RACCheckBox
                    id={String(po.purchaseOrderNumber)}
                    color="primary"
                    onChange={() => onPOSelection(po)}
                    checked={selectedPO === poNumber}
                    classes={{
                      checkbox: clsx(classes.checkbox, classes.mainCheckbox),
                    }}
                  />
                  <div className={classes.mainTableCellWrapper}>
                    <div
                      className={clsx(
                        classes.mainTableCellWidth100,
                        classes.minWidth100
                      )}
                    >
                      <span className={classes.mainTableCell}>
                        {getPONumber(po)}
                      </span>
                    </div>
                    <span>{`${formatDateString(po.createdDate)}`}</span>
                  </div>
                </div>
                {showPODetail && (
                  <RACTable
                    renderTableHead={() => <></>}
                    renderTableContent={() =>
                      renderChildTableContent(
                        po,
                        generateFlatReceivedDetails(po.purchaseOrderDetails)
                      )
                    }
                  />
                )}
              </RACTableCell>
            </>
          </RACTableRow>
        );
      })}
    </>
  );

  const handleActionClick = (isMotorcycle: boolean, receivedId: string, poInUpdatedPOList: UpdatedPOInformation | undefined, poReceived: PurchaseOrderDetail, purchaseOrderId: string, index: number, isSelected: boolean, partialReceivedPOs: UpdatedPOInformation[], setPartialReceivedPOs: React.Dispatch<React.SetStateAction<UpdatedPOInformation[]>>,distributionCenter:any) => {
    const newSerialProps: BolandSerialPropsType = {
      receivedId,
      poInUpdatedPOList: poInUpdatedPOList,
      poReceived: poReceived,
      purchaseOrderId: purchaseOrderId,
      index,
      isSelected: isSelected,
      partialReceivedPOs,
      distributionCenter,
      // setPartialReceivedPOs
    };
    setSerialProps(newSerialProps);

    setReceivingInfoModalOpen(true);

    if (isMotorcycle) {
      setReceivingMotorcycleInfo(true);

    } else {
      setReceivingMotorcycleInfo(false);

    }
  };


  const closeReceivingInfoModal = () => {
    setReceivingInfoModalOpen(false);
  };


  const renderChildTableContent = (
    po: PurchaseOrder,
    poReceivedDetails: PurchaseOrderDetail[],
    // eslint-disable-next-line sonarjs/cognitive-complexity
  ) => (
    <>
      {poReceivedDetails
        ?.flatMap((i) => [i, i])
        .map((poReceived: any, index) => {
          if ( poReceived.quantityCanceled > 0 && poReceived.quantityCanceled >= poReceived.quantityOrdered ) return null;
          
          const { purchaseOrderId } = po;
          const {shippedFromStoreNumber}=po;
          const receivedId = `${purchaseOrderId}-${poReceived?.purchaseOrderDetailId
            }-${poReceived?.purchaseOrderDetailReceivedId || index}`;
          const previousReceivedIdRow = `${purchaseOrderId}-${poReceived?.purchaseOrderDetailId
            }-${poReceived?.purchaseOrderDetailReceivedId || index - 1}`;
          const isPartial = !!poReceived?.partialReasonId;
          const isItemReceived = !!poReceived?.purchaseOrderDetailReceivedId;
          const isPreviouslyReceived =
            isItemReceived && !poReceived?.partialReasonId;
          const isSelected = selectedReceivedDetailPO.includes(receivedId);
          const isTBAgreement = () =>
            queryParamsProp.origin == 'TB' &&
              queryParamsProp.poNumber &&
              queryParamsProp.customerId &&
              queryParamsProp.agreementId &&
              queryParamsProp.storeActionItemId
              ? true
              : false;
          const hasPOLineItemReceivedId =
            !!poReceived?.receivedLineItemDetails?.[0].poLineItemReceivedId;
          const poInUpdatedPOList = poExistInUpdatedList(
            hasPOLineItemReceivedId,
            poReceived,
            index,
            partialReceivedPOs
          );

          bolandSerialProps = {
            receivedId,
            poInUpdatedPOList: poInUpdatedPOList,
            poReceived: poReceived,
            purchaseOrderId: purchaseOrderId,
            index,
            isSelected: isSelected,
            distributionCenter:shippedFromStoreNumber
 
          };

          const isMotorcycle = Array.isArray(poReceived?.vehicleDetails) && poReceived?.vehicleDetails.length > 0;
          if (index % 2 !== 0) {
            return (
              <ReceivedDetailRow
                key={index}
                index={index - 1}
                partialReceivedPO={partialReceivedPOs}
                poReceivedDetail={poReceived}
                isDisabled={
                  !selectedReceivedDetailPO.includes(previousReceivedIdRow)
                }
                isPartial={isPartial}
                isPreviouslyReceived={isPreviouslyReceived}
              />
            );
          }

          return (
            <RACTableRow key={index} backgroundColor="white">
              <>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.checkbox,
                      classes.childTableCellWidth100
                    ),
                  }}
                >
                  <RACCheckBox
                    id={receivedId}
                    color="primary"
                    onChange={() =>
                      isSelected
                        ? setSelectedReceivedDetailPO(
                          selectedReceivedDetailPO.filter(
                            (item) => item !== receivedId
                          )
                        )
                        : setSelectedReceivedDetailPO([
                          ...selectedReceivedDetailPO,
                          receivedId,
                        ])
                    }
                    checked={
                      isSelected ||
                      (isPreviouslyReceived && !isPartial) ||
                      isTBAgreement()
                    }
                    classes={{ checkbox: classes.checkbox }}
                    disabled={isPreviouslyReceived && !isPartial}
                  />
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth170,
                      !isSelected && classes?.disabled
                    ),
                  }}
                ></RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {poReceived?.inventoryNumber || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {trimTextWithTooltip(poReceived?.modelNumber) || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth250,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {trimTextWithTooltip(poReceived?.itemDescription) || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {poReceived?.brand || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth100,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {formatMoney(poReceived?.itemCost)}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150
                    ),
                  }}
                >
                  <ReceiveNowActions
                    isDisabled={!isSelected}
                    isPartialReceivingNowSelected={isPartial}
                    onPartialRefusalSubmitted={(reason, comment, action) => {
                      const updatedPO = handlePartialRefusalSubmitted(
                        purchaseOrderId,
                        reason,
                        comment,
                        poReceived,
                        index,
                        action,
                        partialReceivedPOs
                      );
                      setPartialReceivedPOs(updatedPO);
                      dispatch(setUpdatedPOData(updatedPO));
                    }}
                  />
                </RACTableCell>

                {enableMXPOReceivingValue != "1" ?
                  (<><RACTableCell
                    classes={{
                      root: clsx(
                        classes.paddingTopBottom8,
                        classes.childTableCellWidth150,

                      ),
                    }}
                  >

                    <RACTextField
                      name={`serial-${receivedId}`}
                      value={poReceived?.manufacturerSerialNumber || ''}
                      type="text"
                      inputProps={{ maxLength: 20 }}
                      onBlur={() =>
                        dispatch(setUpdatedPOData(partialReceivedPOs))
                      }
                      onChange={(value) =>
                        setPartialReceivedPOs(
                          addSerialNumberabdBol(
                            purchaseOrderId,
                            value,
                            null,
                            poReceived,
                            index,
                            partialReceivedPOs
                          )
                        )
                      }
                      disabled={!isSelected}
                    />
                  </RACTableCell>
                    <RACTableCell
                      classes={{
                        root: clsx(
                          classes.paddingTopBottom8,
                          classes.childTableCellWidth150
                        ),
                      }}
                    >
                      <RACTextField
                        name={`bol-${receivedId}`}
                        value={
                          poInUpdatedPOList
                            ? poInUpdatedPOList.billOfLading
                            : poReceived?.bol || ''
                        }
                        inputProps={{ maxLength: 20 }}
                        type="text"
                        onBlur={() =>
                          dispatch(setUpdatedPOData(partialReceivedPOs))
                        }
                        onChange={(value) =>
                          setPartialReceivedPOs(
                            addSerialNumberabdBol(
                              purchaseOrderId,
                              null,
                              value,
                              poReceived,
                              index,
                              partialReceivedPOs
                            )
                          )
                        }
                        disabled={!isSelected}
                      />
                    </RACTableCell></>) :
                  (<RACTableCell
                    classes={{
                      root: clsx(
                        classes.paddingTopBottom8,
                        classes.childTableCellWidth150,
                        
                      ),
                    }}>
                      <div className={classes.actionCell}> 
                    <EditIcon 
                      onClick={() => {

                        if (isSelected) {

                          handleActionClick(isMotorcycle, receivedId, poInUpdatedPOList, poReceived, purchaseOrderId, index, isSelected, partialReceivedPOs, setPartialReceivedPOs,shippedFromStoreNumber)
                        }
                      }}
                      style={{ cursor: isSelected ? 'pointer' : 'not-allowed', opacity: isSelected ? 1 : 0.5 }}
                    />
                    </div>

                  </RACTableCell>)
                }
              </>
            </RACTableRow>
          );
        })}
    </>
  );

  const shouldIncludePO = (po: PurchaseOrder) => {

    if (po?.poStatusType !== 'APR') {
      return true;
    }
  
    if (po?.closeDate !== null) {
      return false;
    }
  
    //Include only if PO status is 'APR' and not fully received
    const { totalOrdered, totalCanceled, totalReceived } =
    getTotalPOItems(po.purchaseOrderDetails);

    const expected = Math.max(totalOrdered - totalCanceled, 0);

    const isFullyReceived = expected === totalReceived;

    // Also include when PO when partially receivedthat never produced inventory, so the store can complete receiving.
    const hasAnyRealReceive = po.purchaseOrderDetails?.some((d) =>
      d.purchaseOrderReceivedDetails?.some((r) => !!r.inventoryNumber)
    );

    return !isFullyReceived || !hasAnyRealReceive;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const fetchPurchaseOrders = (isFilterChanged = false) => {
    // eslint-disable-next-line no-console
    console.log(`inside fetchPurchaseOrders`, queryParamsProp, manualPOReceive);
    if (manualPOReceive && queryParamsProp?.origin != 'TB' && queryParamsProp?.origin != 'inventory') return;
    if (initialCallToken?.current) {
      initialCallToken.current?.cancel();
    }
    initialCallToken.current = getCancelTokenSource();

    setApiHasError(false);
    setLoading(true);
    const storeNumber = getSelectedStore();

    const request: GetPurchaseOrderRequest = {
      storeNumber: [storeNumber],
      purchaseOrderType: RegularPOTypes,
      poStatusType: RegularPOStatusTypes,
    };

    if (fromDate && toDate) {
      request.poDateRange = {
        endDate: toDate,
        startDate: fromDate,
      };
    }

    if (poNumber) {
      request.purchaseOrderNumber = poNumber;
      request.coworkerId = user?.employeeId;
      setSearchItemFound(false);
    }
    if (
      queryParamsProp.origin == 'TB' &&
      queryParamsProp.poNumber &&
      queryParamsProp.storeActionItemId
    ) {
      request.purchaseOrderType = ['REG', 'EDN'];
      request.poStatusType = RegularPOStatusTypes;
    }

    getPurchaseOrders(
      request,
      offset,
      RECEIVING_PO_API_LIMIT,
      initialCallToken.current?.token
    )
      .then((response: GetPurchaseOrderResponse) => {
        const hasPO = !!response.purchaseOrders.length;
        if (hasPO) {

          const filteredPOs = isOracleFusionEnabled
            ? response.purchaseOrders.filter(shouldIncludePO)
            : response.purchaseOrders;

          if (
            isFilterChanged ||
            response?.purchaseOrders.length <= RECEIVING_PO_API_LIMIT
          ) {
            setPurchaseOrders(filteredPOs);
          } else {
            setPurchaseOrders([...purchaseOrders, ...filteredPOs]);
          }
          if (poNumber && filteredPOs.length > 0) {
            setSearchItemFound(true);
            setSearchedPOInSection(POSection.RegularPO);
          }
          if (
            queryParamsProp.origin == 'TB' &&
            response?.purchaseOrders.length > 0
          ) {
            setSelectedPO(queryParamsProp?.poNumber);
            onPOSelection(response?.purchaseOrders[0]);
          }
        }

        setHasMore(
          hasPO && response?.purchaseOrders.length === RECEIVING_PO_API_LIMIT
        );
        setLoading(false);
      })
      .catch((err) => {
        if (!err.__CANCEL__) {
          setApiHasError(true);
          setPurchaseOrders([]);
          setLoading(false);
        }
      });
  };

  const reload = () => {
    setOffset(INITIAL_OFFSET);
    setVendorName('');
    setTotalCost('');
    setEta('');
    setBol('');
    setPartialReceivedPOs([]);
    setSelectedReceivedDetailPO([]);
    setSelectedPO('');
    dispatch(setSelectedPOToReceive({} as PurchaseOrder));
    dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
    setPurchaseOrders([]);
    fetchPurchaseOrders(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchPurchaseOrders, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchPurchaseOrders, [offset]);

  useEffect(() => {
    if (reloadData) {
      reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(reload, [poNumber, fromDate, toDate]);

  useEffect(() => {
    setRegularPOLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    if (!expanded) {
      setVendorName('');
      setTotalCost('');
      setEta('');
      setBol('');
      setPartialReceivedPOs([]);
      setSelectedReceivedDetailPO([]);
      setSelectedPO('');
      dispatch(setSelectedPOToReceive({} as PurchaseOrder));
      dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  useMemo(() => {
    if (queryParamsProp.origin == 'TB' && purchaseOrders.length) {
      const { purchaseOrderDetails: podetails } = purchaseOrders[0];
      const selectedPoIds: string[] = [];
      const res = podetails.map((poReceived: any, subIndex: any) => {
        const selectedPoId = `${purchaseOrders[0]?.purchaseOrderId}-${poReceived?.purchaseOrderDetailId
          }-${poReceived?.purchaseOrderDetailReceivedId || subIndex}`;
        selectedPoIds.push(selectedPoId);
        return {
          ...poReceived,
          manufacturerSerialNumber: `${purchaseOrders[0].purchaseOrderNumber}-${subIndex}`,
          bol: 'TireInstall',
        };
      });
      purchaseOrders[0].purchaseOrderDetails = res;
      setSelectedReceivedDetailPO(selectedPoIds);
      setPurchaseOrders(purchaseOrders);
    }
  }, [purchaseOrders, queryParamsProp.origin]);
  const handleRefresh = () => {
    setOffset(INITIAL_OFFSET);
    setVendorName('');
    setTotalCost('');
    setEta('');
    setBol('');
    setPartialReceivedPOs([]);
    setSelectedReceivedDetailPO([]);
    setSelectedPO('');
    dispatch(setSelectedPOToReceive({} as PurchaseOrder));
    dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
    setPurchaseOrders([]);
    const isFilterSelected = !!poNumber || !!fromDate || !!toDate;
    fetchPurchaseOrders(isFilterSelected);
  };

  return (
    <div className={classes.purchaseOrderListWrapper}>
      <div
        className={classes.purchaseOrderList}
        data-testid={regularPOListTestId}
      >
        <div>
          <div className={classes.row}>
            <div className={enableMXPOReceivingValue == "1" ? classes.fieldWidth70percentMX : classes.fieldWidth70percent}>

              <div className={`${classes.field} ${classes.fieldVendorName}`}>
                <RACTextField
                  label={t("Vendor Name")}
                  type="text"
                  name="vendorName"
                  value={vendorName}
                  disabled
                />
              </div>
              {/* <div className={classes.field}> */}
              <div className={`${classes.field} ${classes.fieldTotalCost}`}>
                <FieldWithTooltip
                  id="regularPOTotalCost"
                  currency
                  title={t("Total Cost")}
                >
                  <AutoNumeric
                    name="regularPOTotalCost"
                    value={totalCost}
                    disabled
                  />
                </FieldWithTooltip>
              </div>
              
              
              {/* <div className={classes.field}> */}
              <div className={`${classes.field} ${classes.fieldEta}`}>
                <RACTextField
                  label="ETA"
                  type="text"
                  name="eta"
                  value={eta}
                  disabled
                />
              </div>

              {enableMXPOReceivingValue == "1" ?
                (<div className={`${classes.field} ${classes.fieldBool}`}
                style={{ position: 'relative' }}>
                  <RACTextField
                    label="BOL #"
                    type="text"
                    name={`bol-${bolandSerialProps?.receivedId}`}
                    value={bol}

                    onChange={(value) => setBol(value)}
                    disabled={!bolandSerialProps?.isSelected}
                  />
                  {/* <img src={Scanner} alt="Scanner" className={classes.scannerIcon} /> */}
                  <Scanner className={classes.scannerIcon} />

                </div>) : <></>}           


            </div>
            <div className={clsx(classes.field, classes.fieldFlex)}>
              <Icon classes={{ root: classes.icon }} onClick={handleRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Icon>
            </div>
          </div>
          <div>
            <RACInfiniteScroll
              offset={offset}
              setOffset={setOffset}
              data={purchaseOrders}
              loading={loading}
              hasMore={hasMore}
              hasApiError={hasApiError}
              classes={{
                loader: classes.contentHeight,
                apiError: classes.contentHeight,
                noItems: classes.contentHeight,
              }}
              successContent={
                <RACTable
                  renderTableHead={renderTableHead}
                  renderTableContent={renderTableContent}
                  stickyHeader
                />
              }
            />
          </div>
        </div>
      </div>
      <ReceivingInfoModal
        open={isReceivingInfoModalOpen}
        onClose={closeReceivingInfoModal}
        user={user}
        setPartialReceivedPOs={(res: any) => { setPartialReceivedPOs(res) }}
        serialProps={serialProps}
        partialReceivedPOs={partialReceivedPOs}
        isReceivingMotoryCycleInfo={receivingMotorcycleInfo}
        addSerialNumberabdBol={addSerialNumberabdBol}
        serialNumbers={serialNumbers}
        setSerialNumbers={setSerialNumbers}
        validatedMotorcycleDetails ={ validatedMotorcycleDetails}
        setValidatedMotorcycleDetails = {setValidatedMotorcycleDetails}

      // motorcycleAttributes={motorcycleAttributes}
      // setUpdatedPOData={setUpdatedPOData}
      // dispatch={(res:any)=> {dispatch(res)}}
      />
    </div>
  );
};
